import React, { useEffect, useState } from 'react';
// import './MrdNotification.css';
import LocalStorage from '../../../lib/LocalStorage';
import config from '../../../common/repository/config';
import { toast } from '../../common/Toast';
import { Button, Dropdown, Form, Grid, Header, Icon, Modal } from 'semantic-ui-react';
import Spinner from '../../app/Spinner';

const OutstationExpense: React.FC = () => {
  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState('');
  const [selectedReason, setSelectedReason] = useState('');

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error('Authentication token is missing.');
  
      const response = await fetch(`${config.apiBaseURL}/notification/listOutstation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        } 
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        toast.error(`${response.status} ${response.statusText} ${errorText}`);
      }

      const data = await response.json();
      setNotifications(data.data.items);
      toast.success(`${data.message}`);

    } catch (e) {
      toast.error((e as any).message);
    } finally {
      setLoading(false);
    }

  };

  const handleApprove = async (notificationId: string) => {
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error('Authentication token is missing.');
    
      const payload = {
        notification_id: notificationId 
      };
  
      const response = await fetch(`${config.apiBaseURL}/notification/approveOutstation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify(payload), 
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        toast.error(`${response.status} ${response.statusText} ${errorText}`);
      }
  
      const data = await response.json();

      if (data.success) {
        toast.success(`${data.message}`);
      } else {
        toast.error(`${data.message}`);
      }
      await fetchNotifications();
      
    } catch(e) {
      toast.error((e as any).message);
    }
  }

  const handleReject = async () => {
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error('Authentication token is missing.');
      if (selectedRequest.length === 0) toast.error(`Invalid Request Id`);
      if (selectedReason.length === 0) toast.error(`Invalid Reason`);

      const payload = {
        notification_id: selectedRequest,
        rejectionReason: selectedReason.trim() 
      };
  
      const response = await fetch(`${config.apiBaseURL}/notification/rejectOutstation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify(payload), 
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        toast.error(`${response.status} ${response.statusText} ${errorText}`);
      }
  
      const data = await response.json();

      if (data.success) {
        toast.success(`${data.message}`);
      } else {
        toast.error(`${data.message}`);
      }
      await fetchNotifications();
    } catch(e) {
      toast.error((e as any).message);
    } finally {
      setEditOpen(false);
    }
  }

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Spinner />
      </div>
    );
  }
  const rejectionReason = [
    "Too much expensive",
    "Unauthorized travel",
    "Missing receipts",
    "Unnecessary Travel"
  ]
  const rejectionReasonOptions = rejectionReason.map((reason) => ({
    key: reason,
    text: reason,
    value: reason,
  }));
  return (
    <div className="mrd-notification">
      <h2> Outstation Notification</h2>
      <table className="notification-table">
        <thead>
          <tr>
            <td><strong>Investigator</strong></td>
            <td><strong>Address</strong></td>
            <td><strong>Action</strong></td>
          </tr>
        </thead>
        <tbody>
          {notifications.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ textAlign: 'center' }}>No Outstation notifications.</td>
            </tr>
          ) : (
            notifications.map(notification => (
              <tr key={notification._id}>
                <td>{notification.message} </td>
                 <td>{notification.metadata.request_address} </td>
                <td>
                  <Button
                    primary
                    style={{ backgroundColor: 'green', color: 'white', marginRight: '10px' }}
                    onClick={() => {
                      handleApprove(notification._id)
                    }}
                  >
                    Approve
                  </Button>
                  <Button
                    style={{ backgroundColor: 'red', color: 'white' }}  
                    onClick={() => {
                      setEditOpen(true);
                      setSelectedRequest(notification._id);
                    }}
                  >
                    Reject
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <Modal open={editOpen} onClose={() => {
        setEditOpen(false);
      }} size="mini" closeIcon>
        <Header icon="edit" content="Rejection Reason" />
        <Modal.Content>
          <Form>
            <Grid stackable doubling>
              <Grid.Column>
                <Form.Field>
                <Dropdown
                  search
                  selection
                  placeholder="Select reason"
                  options={rejectionReasonOptions}
                  value={selectedReason}
                  onChange={(_, data) => {
                    setSelectedReason(data.value as string);
                  }}
                />
                </Form.Field> 
              </Grid.Column>
            </Grid>
          </Form>                      
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => {
              setEditOpen(false);
            }}>Cancel</Button>
            <Button color="youtube" onClick={() => handleReject()}>
              <Icon name="save" /> Reject
            </Button>
        </Modal.Actions>
      </Modal>       
    </div>
  );
};

export default OutstationExpense;
  